export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/thumbnail-wellness-obsessed-3d0f47d93af5ae6b2cfa6607bbc49015.png";